//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useEffect, useRef, useState } from 'react';

// ### MUI / STYLES ###
import { useTheme } from '@mui/material/styles';

// === COMPONENTS ===
import Collapsible, { Header } from 'components/Collapsible';
import Styled from 'components/Styled/Styled';
import Field  from './components/Field/Field';

// === API ===
import { on, removeListener } from 'api/prokey/prokey.websocket';

//#endregion


//-----------------------------------------------------------------
export default function Document(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]
 
  const { id } = props;

  const theme = useTheme();

  const [ document , setDocument ] = useState([]);
  const [ has_focus, setHasFocus ] = useState(false);
  
  const ref = useRef();

  //#endregion
  
  //#region [EFFECT]
  
  useEffect( () => {
    const DOCUMENT = 'FILE_DOCUMENT';
    
    //-----------------------------------------------------------------
    function handleDocument( data ) {
      //-----------------------------------------------------------------
      if( id !== data.id ) return;
      setDocument( data );
    }

    on( DOCUMENT, handleDocument );

    return () => {
      removeListener( DOCUMENT, handleDocument );
    }
  }, [] )
  
  useEffect( () => {
    //-----------------------------------------------------------------
    function handleFocus(data) {
      //-----------------------------------------------------------------
      if( id !== data.id && has_focus ) {
        setHasFocus( false );
      }
      if( id !== data.id ) {
        return;
      }
      if( has_focus ) {
        return;
      }
      
      setHasFocus( true );
      ref.current.scrollIntoView({ behavior: "instant", block: "center", inline: "nearest" });
    }

    on( 'FILE_DOCUMENT_FOCUS', handleFocus );

    return () => {
      removeListener( 'FILE_DOCUMENT_FOCUS', handleFocus );
    }
  }, [id, ref, has_focus] );

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    if( !document.is_selected ) return null;
    
    const body = displayFields()
    const bg = has_focus ? { background: '#ffa500'} : { background: theme.palette.primary.main }
    return (
      <Collapsible
        key={id}
        styles={ [{height: 'fit-content'}]}
        header        = {{ children: <Header title={document.name} styles={[ {fontWeight: 'bold'} ]} />, styles:[bg, { color: theme.palette.primary.contrastText }] }}
        header_closed = {{ children: <Header title={document.name} styles={[ {fontWeight: 'bold'} ]} />, styles:[bg, { color: theme.palette.primary.contrastText }] }}
        body          = {{
          children: body,
          styles: [{height: '500px'} ]
        }}
        body_closed   = {{ children: null }}
      />
    )
  }

  //-----------------------------------------------------------------
  function displayFields() {
    //-----------------------------------------------------------------
    const fields = document.fields.map( id => ( <Field key={id} id={id} /> ))
    return (
      <Styled ref={ref} styles={[{overflow:'auto'}]}>
        {fields}
      </Styled>
    );
  }

  //#endregion

  return display();
}